import { useMemo, useCallback } from 'react';
import { AutocompleteInput } from '@/components';
import type { Option } from '@/components/inputs/AutocompleteInput';
import { useRecipientsAutocomplete } from '../../hooks';

export interface RecipientAutocompleteInputProps {
  name: string;
  placeholder: string;
  value: string | undefined;
  onValueChange: (next: string) => void;
}

export default function RecipientAutocompleteInput({
  name,
  placeholder,
  value,
  onValueChange,
}: RecipientAutocompleteInputProps) {
  const { recipientOptions, isRecipientsLoading } = useRecipientsAutocomplete({
    search: value,
    minLength: 3,
  });
  const selected = useMemo((): Option | null => {
    if (!(value?.trim() ?? '')) return null;
    return { label: value!, data: value! };
  }, [value]);
  const onSelect = useCallback(
    (option: Option | null) => {
      if (!option) {
        onValueChange('');
        return;
      }
      if (typeof option.data !== 'string') return;
      onValueChange(option.data);
    },
    [onValueChange]
  );

  return (
    <AutocompleteInput
      name={name}
      placeholder={placeholder}
      value={selected}
      inputValue={value ?? ''}
      onChange={onSelect}
      onInputChange={onValueChange}
      options={recipientOptions}
      required={false}
      loading={isRecipientsLoading}
      freeSolo
    />
  );
}
